export default __webpack_public_path__ + "static/media/smart-apy-image.51a5a65a.png";